import { pushNotifications } from '@gem/modules/permissions';

export const requestPermission = async (): Promise<void> => {
  if (pushNotifications.getCurrentPermission() === 'default') {
    await pushNotifications.requestPermission();
  }
};
